<template>
<div>
    <div
        id="basic"
        class="wrapper"
    >
        <!-- 内容は以下に記述して下さい。 -->
        <!-- 基本情報 -->
        <app-error-list/>
        <app-section label="基本情報">
            <h3 slot="h3">
                <parts-arrow category="基本情報">1</parts-arrow>
                <span>基本情報を入力して下さい。</span>
            </h3>
            <app-box
                :available="true"
                label="住宅タイプの名称" 
                class="flex_column"
                @click="guideTransition"
                name="bsc_name"
            >
                <app-text
                    label=""
                    unit=""
                    v-model="bsc_name"
                    value="〇〇〇〇邸"
                    class="str90per"
                />
            </app-box>
            <app-box
                :available="true"
                label="プログラムの種類"
                class="flex_column"
                @click="guideTransition"
                name="bsc_type"
            >
                <app-radio
                    v-for="(name, value) in master.bsc_type"
                    v-model="bsc_type"
                    :value="value"
                    unit=""
                    :key="'bsc_type' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <!-- 一般住宅の場合にのみ表示-->
            <app-box
                v-if="bsc_type == 1"
                :available="true"
                label="住宅の建て方"
                class="flex_column"
                @click="guideTransition"
                name="bsc_tatekata"
            >
                <app-radio
                    v-for="(name, value) in master.bsc_tatekata"
                    v-model="bsc_tatekata"
                    :value="value"
                    unit=""
                    :key="'bsc_tatekata' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                :available="true"
                label="居室の構成"
                class="flex_column kyoshitsu_kousei"
                @click="guideTransition"
                name="bsc_kyoshitsu_kousei"
            >
                <app-radio
                    v-for="(name, value) in master.bsc_kyoshitsu_kousei"
                    v-model="bsc_kyoshitsu_kousei"
                    :value="value"
                    unit=""
                    :key="'bsc_kyoshitsu_kousei' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                label="その他の居室の有無"
                :available="true"
                v-if="bsc_kyoshitsu_kousei == '2'"
            >
                <app-radio
                    v-for="(name, value) in master.bsc_sonotakyoshitsu"
                    v-model="bsc_sonotakyoshitsu"
                    :value="value"
                    unit=""
                    :key="'bsc_sonotakyoshitsu' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                label="非居室の有無"
                :available="true"
                v-if="bsc_kyoshitsu_kousei == '2'"
            >
                <app-radio
                    v-for="(name, value) in master.bsc_hikyoshitsu"
                    v-model="bsc_hikyoshitsu"
                    :value="value"
                    unit=""
                    :key="'bsc_hikyoshitsu' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <!-- 一般住宅・気候風土適応住宅の場合にのみ表示-->
            <app-box
                v-if="bsc_type == 1 || bsc_type == 2"
                :available="true"
                label="床面積"
                class="flex_column yuka_menseki"
                @click="guideTransition"
                name="bsc_nobeyuka_menseki"
            >
                <app-text
                    label="主たる居室"
                    unit="m2"
                    v-model="bsc_shukyoshitsu_menseki"
                    :step="0.01"
                    class="number"
                    subscript="(小数点以下2桁)"
                />
                <app-text
                    v-if="bsc_kyoshitsu_kousei == 1 || bsc_sonotakyoshitsu != 2"
                    label="その他の居室"
                    unit="m2"
                    v-model="bsc_sonotakyoshitsu_menseki"
                    :step="0.01"
                    class="number"
                    subscript="(小数点以下2桁)"
                />
                <app-text
                    label="合計"
                    unit="m2"
                    v-model="bsc_nobeyuka_menseki"
                    :step="0.01"
                    class="number"
                    subscript="(小数点以下2桁)"
                />
            </app-box>
            <app-box
                :available="true"
                label="地域の区分"
                class="flex_row env_chiki"
                @click="guideTransition"
                name="env_chiki"
                url="https://house.lowenergy.jp/program#solar_radiation_area"
                link-to="tool"
            >
                <app-radio
                    v-for="count in 8"
                    v-model="env_chiki"
                    :value="count.toString()"
                    unit=""
                    :key="count"
                >
                    {{count}}地域
                </app-radio>
                <information-box title="令和1年11⽉16⽇に新しい地域区分が施⾏されました。">
                    <p>地域の区分は、<a href="https://house.lowenergy.jp/dictionary/basic#env_chiki" target="guide" class="target_blank">こちら</a>を参考に選択します。</p>
                </information-box>
            </app-box>
            <app-box
                :available="true"
                label="年間の日射地域区分の指定"
                class="flex_column"
                @click="guideTransition"
                name="bsc_solarlv_specify"
                link-to="tool"
            >
                <app-radio
                    v-for="(name, value) in master.bsc_solarlv_specify"
                    v-model="bsc_solarlv_specify"
                    :value="value"
                    unit=""
                    :key="'bsc_solarlv_specify' + value"
                >
                    {{name}}
                </app-radio>
                <information-box
                    title="太陽光発電設備または太陽熱利用設備を設置する場合"
                >
                    <p>年間の日射地域区分を選択します。</p>
                </information-box>
            </app-box>
            <app-box
                label="年間の日射地域区分"
                :available="true"
                url="https://house.lowenergy.jp/program#solar_radiation_area"
                v-if="bsc_solarlv_specify == '2'"
            >
                <app-radio
                    v-for="(name, value) in master.bsc_solarlv"
                    v-model="bsc_solarlv"
                    :value="value"
                    unit=""
                    :key="'bsc_solarlv' + value"
                >
                    {{name}}
                </app-radio>
                <information-box
                    title="令和1年11月16日に新しい地域区分が施行されました。"
                >
                    <p>地域の区分は<a href="https://house.lowenergy.jp/dictionary/basic#bsc_solarlv_specify" target="guide" class="target_blank">
                    こちら</a>を参考に選択します。</p>
                </information-box>
            </app-box>
        </app-section>
        <!-- 内容ここまで -->
    </div>
</div>
</template>

<script>
/**
 * 詳細版基本情報入力画面
 * 
 * [算出プロパティ]
 * 詳細版インタフェイス定義の同名項目に準ずる
 * 
 * [ウォッチャ]
 * bsc_tatekata ... 住宅の建て方が「共同住宅」になった場合、外皮性能の評価方法は強制的に「当該住戸の外皮面積を用いて外皮性能を評価する」に変更
 * 
 * [イベント処理]
 * インタフェイス定義済み項目の更新時 ... Storeの該当するキーのデータも更新される
 */
import help from "@/mixins/help"
import master from "@/mixins/master"
import { mapGetters, mapActions } from 'vuex'
import { mapComputedProperties } from '@/util'

export default {
    name:"PageBasicDialogForm",
    computed: {
        ...mapGetters('data', {
            data:'getData',
        }),
        ...mapComputedProperties([
            'bsc_name',
            'bsc_tatekata',
            'bsc_type',
            'bsc_kyoshitsu_kousei',
            'bsc_sonotakyoshitsu',
            'bsc_hikyoshitsu',
            'bsc_shukyoshitsu_menseki',
            'bsc_sonotakyoshitsu_menseki',
            'bsc_nobeyuka_menseki',
            'env_chiki',
            'bsc_solarlv_specify',
            'bsc_solarlv',
            'ip_houhou'
        ]),
    },
    mixins:[help, master],
    watch:{
        /**
         * 住宅の建て方が「共同住宅」になった場合、外皮性能の評価方法は強制的に「当該住戸の外皮面積を用いて外皮性能を評価する」に変更
         */
        bsc_tatekata(newValue){
            if (newValue === '2') {
                this.ip_houhou = '1'
            }
        }
    },
    methods:{
        ...mapActions('data', ['update']),
    }
}

</script>

<style scoped>
.yuka_menseki >>> .grid_2 label{
    display: inline-block;
    width: 7em;
}

.kyoshitsu_kousei >>> .grid_2 .radio_sub_box{
    grid-template-columns: 11em 1fr;
    -ms-grid-columns: 11em 1fr;
}
.env_chiki >>> .grid_2 {
    flex-flow: row wrap;
}
.env_chiki >>> .information {
    width:100%;
}
</style>

